import React, { useEffect, useState } from 'react';
import { css } from 'emotion';
import { connect } from 'react-redux';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from "lodash/isEqual";
import { ElementRoot } from '@whalecloud/page-builder-core/components/ElementRoot';
import { Table as DesignTable } from '@whalecloud/fdx';
import FormItem from "@whalecloud/page-builder-core/components/Render/components/FormItem";
import { getElement, getParentFormWidthChildren } from '@whalecloud/page-builder-core/components/Render/selectors';
import { makeEventProps } from '@whalecloud/page-builder-core/utils/common';
import { tableRegExp, calculateScrollWidth } from '@utils/util';

const left = css({ textAlign: 'left' });

const handleColumns = (props: any) => {
  const columnsRender: Array<any> = [];
  const columns: Array<any> = [];
  const { element, state, nameSpace } = props;
  const { elements = [] } = element;
  elements.forEach((childId, index) => {
    const child = getElement(state, childId.id, nameSpace);
    columns.push({
      ...child.data.columnSettings,
    });
    columnsRender.push({
      ...child.data.columnSettings,
      title: child.data.columnSettings.title,
    });
  });
  return [columnsRender, columns];
};
const Table = props => {
  const { element, nameSpace, formElement, updateElement } = props;
  const [columnsRender] = handleColumns(props);
  const { tableSettings, formSettings, settings, className: styleClassName = '' } = element.data;
  const { horizontalAlign = 'left' } = settings;
  const { scroll, autoInitialize, dataSource = [], checked = [], rowSelection, hideLabel = false, ...otherSetting } = tableSettings;
  const hideLabelProps = hideLabel ? { hideLabel : true } : {}
  const { rules = [] } = formSettings;
  const [scrollWidth, setScrollWidth] = useState(0);

  const eventProps = makeEventProps(element.data.events, nameSpace);

  const ruleProps: any = {};
  if (rules.length > 0) {
    ruleProps.rules = [{ required: rules[0].required, validator: (rule, value) => tableRegExp(rule, value, dataSource, rules[0]) }]
  }

  const handleResize = (len) => {
    setTimeout(() => {
      setScrollWidth(calculateScrollWidth(formElement, element, len, false, 'render'));
    }, 200)
  }

  useEffect(() => {
    window.addEventListener('resize', () => handleResize(columnsRender.length));
    return () => {
      window.removeEventListener('resize', () => handleResize(columnsRender.length));
    }
  }, [scrollWidth]);

  useEffect(() => {
    handleResize(columnsRender.length);
  }, [columnsRender.length]);

  const rowSelectionConfig = {
    ...rowSelection,
    onChange: (selectedRowKeys, selectedRows) => {
      // 更新 updataelement 将选中的值放在
      const newElement = cloneDeep(element);
      const newDataSource = [];
      newElement.data.tableSettings.dataSource.forEach((item, index) => {
        if (selectedRowKeys.indexOf(item[otherSetting.rowKey]) > -1) {
          item.checked = true;
        }
        newDataSource.push(item);
      });
      newElement.data.tableSettings.dataSource = newDataSource;
      newElement.data.tableSettings.checked = selectedRowKeys;
      updateElement({ element: newElement }, nameSpace)
    },
    selectedRowKeys: checked,
  };

  const className = 'webiny-pb-base-page-element-style webiny-pb-page-element-table';
  return (
    <ElementRoot className={'webiny-pb-base-page-element-style'} element={element} elScrollWidth={scrollWidth}>
      {({ getAllClasses, elementStyle }) => (
        <div style={{ textAlign: horizontalAlign }}>
          <FormItem
            id={element.id}
            style={elementStyle}
            className={getAllClasses('webiny-pb-base-page-element-style', 'webiny-pb-page-element-input', left)}
            {...formSettings}
            {...ruleProps}
            {...hideLabelProps}
            valuePropName="dataSource"
            trigger="change"
          >
            <DesignTable
              style={elementStyle}
              dataSource={autoInitialize ? dataSource : []}
              {...otherSetting}
              columns={columnsRender}
              scroll={{ x: (scroll && scroll.x) || scrollWidth || 0, y: (scroll && scroll.y) || 0 }}
              {...eventProps}
              className={`${className} ${styleClassName}`}
              // rowSelection={rowSelectionConfig}
              rowSelection={tableSettings.rowSelection ? {
                onChange: (keys, rows) => {
                  eventProps.onSelect && eventProps.onSelect(rows)
                },
                ...tableSettings.rowSelection
              } : null}
              onRow={record => ({
                onDoubleClick: () => eventProps.onDoubleClick(record) || (() => { }),
                onClick: () => eventProps.onClick(record) || (() => { }),
                ...eventProps.onRow ? eventProps.onRow() : {}
              })}
            />
          </FormItem>
        </div>
      )}
    </ElementRoot>
  );
};

export default connect<any, any, any>(
  (state, props) =>
    ({ state, formElement: getParentFormWidthChildren(state, props.element.id, props.nameSpace) }),
  null,
  null,
  { areStatePropsEqual: isEqual }
)(Table);
